jQuery(".accreditation-logo-slider").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    pauseOnFocus: true,
    pauseOnHover: true,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 8,
                centerPadding: "60px",
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 7,
                centerPadding: "50px",
            },
        },
        {
            breakpoint: 800,
            settings: {
                slidesToShow: 6,
                centerPadding: "20px",
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 4,
                centerPadding: "20px",
            },
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 2,
                centerPadding: "20px",
            },
        },
    ],
});
